export const AUCTION_PREFIX = 'auction';
export const METADATA_PREFIX = 'metadata';
export const EDITION_PREFIX = 'edition';
export const METAPLEX_PREFIX = 'metaplex';
